export default {
  // eslint-disable-next-line no-undef
  ...configSettings ,
  productSetupApiKey:''
};
